import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from "../carrier/response-container";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LabMDM } from "../masterdata/models/lab";
import { tap, timeout } from 'rxjs/operators';


/**    
 * @author Vyshali Bhat 
 * @description Supreme run pending reaction plates service 
 */
@Injectable()
export class PendingPlatesService {
    defaultTimeout = 600000;
    constructor(private http: HttpClient) { }

    /**
    * @function
    * @param MaterialType 
    * @description Make service call to reaction set endpoint 
   */
    getPendingReactionPlates(reactionPlateState: string): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate';
        let requestParam = new HttpParams().set('reactionPlateState', reactionPlateState);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getNewReactionPlate(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/create';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getQuadrants(id: string): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/quadrants';
        let requestParam = new HttpParams().set('plateId', id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getQuadrantsfromSearchedBarcode(barcode: string): Observable<BBResponseContainer> {
      let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/search';
      let requestParam = new HttpParams().set('barcode', barcode);
      const options = url ? { params: requestParam } : {};
      return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
          error.url = url;
      }));
  }
}
